import React, { Component } from 'react';
import { connect } from 'react-redux';
import './NewProject.css';
import { getCurrentStage } from 'components/admin/projects/creation/store/selectors';
import { newProject } from 'components/admin/projects/creation/store/actions';
import GeneralContractorSelection from 'components/admin/projects/creation/GeneralContractorSelection';
import ClientSelection from 'components/admin/projects/creation/ClientSelection';
import BuildingSelection from 'components/admin/projects/creation/BuildingSelection';
import Success from 'components/admin/projects/creation/Success';
import { createProject } from 'components/admin/projects/creation/store/actions';
import { getProjectForm } from 'components/admin/projects/creation/store/selectors';

class NewProject extends Component {
  constructor(props) {
    super(props);

    props.dispatch(newProject());
  }

  handleCreateProject = () => {
    this.props.dispatch(createProject(this.props.projectForm));
  };

  renderCurrentStage = () => {
    let stage;

    switch (this.props.currentStage) {
      case 'gc-selection':
        stage = <GeneralContractorSelection />;
        break;

      case 'client-selection':
        stage = <ClientSelection />;
        break;

      case 'building-selection':
        stage = (
          <BuildingSelection
            submitButtonLabel="Create Project"
            submitFunction={this.handleCreateProject}
          />
        );
        break;

      case 'success':
        stage = <Success />;
        break;

      default:
        stage = null;
    }

    return stage;
  };

  render() {
    return (
      <div className="new-project">
        <div className="full-title">Create Project</div>

        <div className="content-container">{this.renderCurrentStage()}</div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentStage: getCurrentStage(state),
    projectForm: getProjectForm(state),
  };
})(NewProject);



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/NewProject.js